// Copyright (c) 2016 Deere & Company

import './download-to-excel-for-panel.scss';
import React, {PropTypes} from 'react';

const DownloadToExcelForPanel = props =>
    <div className='download-to-excel-for-panel'>
        <span
            className='excel-icon'
            onClick={props.onDownload}
        />
    </div>;

DownloadToExcelForPanel.displayName = 'DownloadToExcelForPanel';
DownloadToExcelForPanel.propTypes = {
    onDownload: PropTypes.func.isRequired
};

export default DownloadToExcelForPanel;



// WEBPACK FOOTER //
// ./src/shared/components/download-to-excel-for-panel/index.js